// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lx8c4E {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  max-width: 100% !important;
  height: 100%;
  min-height: 500px;
  padding: 3rem;
  text-align: center;
  border: none;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.bqwPPx {
  width: 72px;
  height: 72px;
  background-color: #e9ffe4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.yg0533 {
  color: #d64000;
  font-size: 24px;
}

.fybDC_ {
  font-family: var(--font-family-base);
  margin-bottom: var(--spacing-1);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
}

.ochwaM {
  font-family: var(--font-family-base);
  margin-bottom: var(--spacing-3);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-180);
}

.zuqYf3 {
  height: 100%;
}

.zuqYf3 .mainCard,
.zuqYf3 .singleColumn,
.zuqYf3 .cardsContainer,
.zuqYf3 .cardsContainer .mainCard,
.zuqYf3 .cardsContainer.singleColumn .mainCard,
.zuqYf3 main,
.zuqYf3 main.MpqoQS {
  max-width: 100% !important;
  min-height: 80vh;
}

.personHiringBlockedContainer .cardsContainer.singleColumn .mainCard {
  max-width: 100% !important;
}

.personHiringBlockedContainer main {
  max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/PersonHiringBlocked/PersonHiringBlocked.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100% !important;\n  max-width: 100% !important;\n  height: 100%;\n  min-height: 500px;\n  padding: 3rem;\n  text-align: center;\n  border: none;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n}\n\n.iconContainer {\n  width: 72px;\n  height: 72px;\n  background-color: #e9ffe4;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.icon {\n  color: #d64000;\n  font-size: 24px;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  margin-bottom: var(--spacing-1);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n}\n\n.description {\n  font-family: var(--font-family-base);\n  margin-bottom: var(--spacing-3);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-180);\n}\n\n.personHiringBlockedContainer {\n  height: 100%;\n}\n\n.personHiringBlockedContainer :global(.mainCard),\n.personHiringBlockedContainer :global(.singleColumn),\n.personHiringBlockedContainer :global(.cardsContainer),\n.personHiringBlockedContainer :global(.cardsContainer) :global(.mainCard),\n.personHiringBlockedContainer :global(.cardsContainer.singleColumn) :global(.mainCard),\n.personHiringBlockedContainer main,\n.personHiringBlockedContainer main.mainCard {\n  max-width: 100% !important;\n  min-height: 80vh;\n}\n\n:global(.personHiringBlockedContainer .cardsContainer.singleColumn .mainCard) {\n  max-width: 100% !important;\n}\n\n:global(.personHiringBlockedContainer main) {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `lx8c4E`,
	"iconContainer": `bqwPPx`,
	"icon": `yg0533`,
	"title": `fybDC_`,
	"description": `ochwaM`,
	"personHiringBlockedContainer": `zuqYf3`,
	"mainCard": `MpqoQS`
};
module.exports = ___CSS_LOADER_EXPORT___;
